import xw from 'xwind';
import styled from '@emotion/styled';

const Label = styled.label(xw`block mb-1 text-xs sm:text-sm text-primary`);

export default Label;
